export const NavbarLinks = [
    {
        title: "Home",
        path: "/",
    },
    {
        title: "Services",
        path: "/services",
    },

    {
        title:"Portfolio",
        path:"/portfolio",
    },
    {
        title:"About Us",
        path: "/aboutus",
    },
    {
        title:"Contact Us",
        path: "/contactus",
    },
   
]